import { render } from "./tw-alert.vue?vue&type=template&id=4d7eb74c"
import script from "./tw-alert.vue?vue&type=script&lang=js"
export * from "./tw-alert.vue?vue&type=script&lang=js"
script.render = render

export default script